import { render, staticRenderFns } from "./association-list-item.vue?vue&type=template&id=77f8607e"
import script from "./association-list-item.vue?vue&type=script&lang=js"
export * from "./association-list-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports